const pluckCards = (deck, index) => {
  let start = index * 2 + 5
  let end = start + 2
  return deck.slice(start, end)
}

export default pluckCards
